const axios = require('./axios');
const isBrowser = typeof window === 'object';

const LOCALSTORAGE_IDENTIFIER = 'token';


const Apicall = {};
/*
const removeEmpty = (obj) => {
    const newObj = {};
    Object.keys(obj).forEach(function (k) {
      if (obj[k] && typeof obj[k] === "object") {
        newObj[k] = removeEmpty(obj[k]);
      } else if (obj[k] != null) {
        newObj[k] = obj[k];
      }
    });
    return newObj;
  }
*/

 


  Apicall.loginByAuth = async (email, password) => {
   
   
    const {data} = await axios.post('user/verifyUser',  {}, { params: { ///user/verifyUser
      
                    email: email,
                    password : password
           }
        }).catch((error) => {
          console.log(error);
        });

    const {token} = data;
  
    if (isBrowser) {
        localStorage.setItem(LOCALSTORAGE_IDENTIFIER, token);
    }

   
   // axios.defaults.headers.common.Authorization = `${token}`; //Bearer

    return token;
};

Apicall.registerByAuth = async (email, password) => {
    const {data} = await axios.post('/v1/auth/register', {
        username: email,
        password: password
    });
    const {token} = data;  
    if (isBrowser) {
        localStorage.setItem(LOCALSTORAGE_IDENTIFIER, token);
    }
    return token;
};


Apicall.getProfile = async () => {
    const token = localStorage.getItem(LOCALSTORAGE_IDENTIFIER);
    axios.defaults.headers.common.Authorization = `${token}`; //Bearer
 
    const {data} = await axios.get('user/getProfile');
    return data;
};

Apicall.getCompanyProfile = async () => {  
    const {data} = await axios.get('company/getCompany');
    return data;
};

Apicall.callAnyApi = async (url,object) => {
 
  
  
    const {data} = await axios.post(url,object);    
  
    return data;
};


Apicall.uploadFile = async (file, onUploadProgress,id,entityId,description,specialFile) => {

  let formData = new FormData();
  formData.append("file", file);
  formData.append("id", id);
  formData.append("entityId", entityId);
  formData.append("description", description);
  formData.append("specialFile", specialFile);

  try{
       return await axios.post("file/uploadFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress,
        });    
  }catch(error){    
      return [''];
  }
}


Apicall.downloadExceFile = async (url,object) => {  

  try{
   
       return await axios.post(url, object, {
          'responseType': 'blob',
          headers: {            
          //  'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8', //'application/vnd.ms-excel;charset=UTF-8',
            
          }
        });    
  }catch(error){    
      return null;
  }
}

Apicall.getFile = (id) => {  
  return  axios.get('basic/getFileBase64?id='+id);
    
};

Apicall.getBaseURL =  () => {
 

    
    return axios.defaults.baseURL;

};

//module.exports = Apicall;
export default Apicall;